import RechargeCenter from '@/views/mobile/RechargeCenter/index'

// 定义路由路径数列表
export default [{
  path: '/rechargeCenter',
  name: '会员充值',
  component: RechargeCenter
}]



// WEBPACK FOOTER //
// ./src/views/mobile/RechargeCenter/routers/index.js